import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { PageSkeleton } from "@/components/common/PageSkeleton";
import { useOrgParamSync } from "@/hooks/useOrgParamSync";

/**
 * The layout's page outlet, held while the address's `?org=` is being read
 * into the scope bar.
 *
 * A page rendered before the selection is applied would fetch for the
 * previous organization, and one whose reads do not follow the bar would keep
 * those rows. The hold is a frame on Back or Forward and the org lists' round
 * trip on a reload; the skeleton is the route's own, so the hold and the
 * page's loading state read as one.
 */
export function ScopedOutlet() {
  const { holding } = useOrgParamSync();
  if (holding) return <PageSkeleton />;
  return (
    // Lazy route loading is isolated here so the shell (and theme) never
    // unmounts on navigation. `PageSkeleton` takes its shape from the route,
    // because this fallback renders before the lazy page exists and cannot
    // ask it; the page's own data skeleton reads the same answer, so the two
    // cannot disagree on reload.
    <Suspense fallback={<PageSkeleton />}>
      <Outlet />
    </Suspense>
  );
}
